// 尺寸454*320
import React from 'react'
import SkuCheckPage from '@/pages/AndroidDevice/skuCheck/skuCheck'
const ReprintHoneywellPage = () => {
  return <SkuCheckPage checkType="Honeywell"></SkuCheckPage>
}
export default ReprintHoneywellPage
